import React from 'react';
import { Helmet } from 'react-helmet-async';
import { IAnalyticsCartInfo, IDigitalData, buildDynamicInfo } from '../../components/basic/analytics';
import { useContent } from '../../providers/content/hook';
import { getURIAsString } from '../../utils/browserUtils';
import { getKPRegion } from '../../utils/regionUtils';

export enum Kp2020ToolsENUM  {
  PD_MASTER = 'pdMaster',
  VTO = 'vto'
}
const PROD_DOMAIN = 'store.kaiserpermanente.org'
const ADOBE_CJA = {
  PROD: 'https://assets.adobedtm.com/dca8f73c45d4/2a905bf4b2f6/launch-88272e536220.min.js',
  NON_PROD: 'https://assets.adobedtm.com/dca8f73c45d4/2a905bf4b2f6/launch-94b9c8aa45ba-development.min.js'
}
const getCJAURL = () => {
  return window?.location?.hostname == PROD_DOMAIN ? ADOBE_CJA.PROD : ADOBE_CJA.NON_PROD
}


const getDigitalData = (PAGE_NAME: string, LANG: string) => {
  const PRIMARY_CATEGORY = "kporgstore"
  const STORE = 'vision'
  const REGION = getKPRegion()?.toLowerCase();
  const SUB_CATEGORY = `${PRIMARY_CATEGORY}:${STORE}:${LANG}`
  const PAGE = getURIAsString().replaceAll('/', ':') || ':home'
  const PAGE_URI = (getURIAsString() || 'home').split('/')
  let digitalData: IDigitalData = {
    page: {
      pageInfo: {
        base: `${SUB_CATEGORY}${PAGE}`,
        pageName: `${SUB_CATEGORY}${PAGE}`
      },
      category: {
        primaryCategory: PRIMARY_CATEGORY,
        subCategory1: SUB_CATEGORY,
        subCategory2: `${SUB_CATEGORY}:${REGION}`,
      }
    },
    user: {
      profile: {},
      segment: {},
      toolsUsed:{}
    },
    global: {
      feature_name: PAGE_NAME,
      guid: ""
    }
  }
  buildDynamicInfo(digitalData)
  let counterCategoryId = 2
  let prevCategory = digitalData.page.category.subCategory2
  for (const URI of PAGE_URI) {
    if (URI !== '') {
      let currCategory = `${prevCategory}:${URI}`
      digitalData.page.category[`subCategory${++counterCategoryId}`] = currCategory
      prevCategory = currCategory
    }
  }
  return digitalData
}

export const setProfileToolsUsed =(toolName : Kp2020ToolsENUM) => {
    if(window) {
      window.digitalData.user.toolsUsed = {
      ...window?.digitalData?.user?.toolsUsed
      }
      
      window.digitalData.user.toolsUsed[toolName] = true
    }
  }
  
  
export const getCurrentProductData = () => {
  return window?.digitalData?.productInfo;
  }

export const setCartInfo = (cartInfo :IAnalyticsCartInfo) => {
  if(window) {
    window.digitalData.cartInfo = cartInfo ;
  }
 };
  
const SEO: React.FC = ({ children }) => {
  const LANG = 'en'
  const { content } = useContent();
  const PAGE_NAME = content?.page?.pageTitle || 'Home'
  const title = `${PAGE_NAME} | Vision Essentials`
  const SEO = {
    description: content?.page?.seo?.description || 'Kaiser Permanente E-Commerce Platform',
    keywords: content?.page?.seo?.keywords || 'Vision Essentials, Kaiser Permanente, Online Shopping, Eyeglasses, Sunglasses, Contact Lens'
  }

  return (
    <Helmet htmlAttributes={{ LANG }}>
      <title>{title}</title>
      <meta http-equiv="x-dns-prefetch-control" content="on" />
      <meta charset="utf-8" />
      <link rel="preconnect" href="https://assets.adobedtm.com" />
      <link rel="preconnect" href="https://cdn.contentstack.io" />
      <link rel="preconnect" href="https://images.contentstack.io" />
      <meta name="description" content={SEO.description} />
      <meta name="keywords" content={SEO.keywords} />
      <meta name="google" content="nositelinkssearchbox" />
      <meta name="google-site-verification" content="" />

      <meta property="og:title" content={title} data-testid="og-title" />
      <meta property="og:description" content={SEO.description} data-testid="og-desc" />
      <meta property="og:url" content="https://www.store.kaiserpermanente.org" data-testid="og-url" />
      <meta property="og:image" content="https://images.contentstack.io/v3/assets/bltd38de548fe5a8d52/blt5ab550f87fc8a948/kp2020logo.svg" data-testid="og-img" />

      <link rel="canonical" href="https://www.store.kaiserpermanente.org" />
      <meta http-equiv="content-type" content="text/html; charset=UTF-8" />
      <script src={getCJAURL()} async></script>
      <script type="text/javascript">
        {`var digitalData = ${JSON.stringify(getDigitalData(PAGE_NAME, LANG))}`}
      </script>
    </Helmet>
  );
};


export default SEO;
